<template>
    <div class="shadow bg-white">
        <h1 class="flex p-6 bg-blue-50 font-bold items-center justify-between">
        {{ title }}
            <button @click="$emit('input', false)" class="text-sm px-3 mr-3 py-1 rounded-lg bg-red-200 text-red-800">
                <v-icon style="color: inherit;">mdi-close</v-icon>
            </button>
        </h1>
        <div class="p-6 mt-3">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'modalTemplate',
    props: ['value', 'title']
}
</script>

<style>

</style>